import React, { useState, useEffect } from 'react';
import { bool, func, oneOf, shape, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import routeConfiguration from '../../routeConfiguration';
import config from '../../config';
import { createResourceLocatorString } from '../../util/routes';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import { propTypes } from '../../util/types';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  stripeAccountClearError,
  getStripeConnectAccountLink,
} from '../../ducks/stripeConnectAccount.duck';
import {
  NamedRedirect,
  // LayoutSideNavigation,
  // LayoutWrapperMain,
  // LayoutWrapperAccountSettingsSideNav,
  // LayoutWrapperTopbar,
  // LayoutWrapperFooter,
  // Page,
  StripeConnectAccountStatusBox,
  // UserNav,
} from '../../components';
import { StripeConnectAccountForm } from '../../forms';
// import { TopbarContainer } from '..';
import { savePayoutDetails, loadData, removeSubscription, reactivateSubscription, fetchPortalSession } from './StripePayoutPage.duck';

import css from './StripePayoutPage.css';

import ContainerWrapper from '../../custom-components/wrappers/container-wrapper/ContainerWrapper';
import PageWrapper from '../../custom-components/wrappers/page-wrapper/PageWrapper';
import Footer from '../../custom-components/elements/footer/Footer';

// import DashboardLayoutWrapper from '../../custom-components/wrappers/dashboard-layout-wrapper/DashboardLayoutWrapper';
// import DashboardPaymentsWrapper from '../../custom-components/wrappers/dashboard-payments-wrapper/DashboardPaymentsWrapper';
import SettingsLayoutWrapper from '../../custom-components/wrappers/settings-layout-wrapper/SettingsLayoutWrapper';
import NavBarWrapper from '../../custom-components/wrappers/navbar-wrapper/NavBarWrapper';
import NavBar from '../../custom-components/elements/nav-bar/NavBar';

import classnames from 'classnames';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import SwitchToggle from '../../custom-components/elements/switch-toggle/SwitchToggle';
import PriceTag from '../../custom-components/elements/price-tag/PriceTag';
// import Button from '../../custom-components/elements/Button/Button';

// import { ProfileSettingsForm } from '../../forms';
// import { PayoutDetailsIndividualAccount } from '../../forms';
// import * as validators from '../../util/validators';
// import { isUploadImageOverLimitError } from '../../util/errors';
// import { Form, Avatar, ImageFromFile, IconSpinner, FieldTextInput } from '../../components';
// import { faLock, faMobile, faUser, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
// import { faPaypal } from '@fortawesome/free-brands-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router-dom';
// import { createHashHistory } from 'history';
// import { types as sdkTypes } from '../../util/sdkLoader';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';


// import { createSlug } from '../../util/urlHelpers';
//
// import { findRouteByRouteName } from '../../util/routes';

import axios from 'axios';
import { fetchCurrentUser } from '../../ducks/user.duck';
import PaymentTable1 from '../../custom-components/elements/payment-table/PaymentTable1';
import PaymentTable2 from '../../custom-components/elements/payment-table/PaymentTable2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from 'react-tooltip';
import { checkProfileCompleted } from '../../custom-ducks/utility.duck';
import MainDashboardWrapper from '../../components/MainDashboardWrapper/MainDashboardWrapper';
// import Offer from '../../assets/30off.png';

const STRIPE_ONBOARDING_RETURN_URL_SUCCESS = 'success';
const STRIPE_ONBOARDING_RETURN_URL_FAILURE = 'failure';
const STRIPE_ONBOARDING_RETURN_URL_TYPES = [
  STRIPE_ONBOARDING_RETURN_URL_SUCCESS,
  STRIPE_ONBOARDING_RETURN_URL_FAILURE,
];

// Create return URL for the Stripe onboarding form
const createReturnURL = (returnURLType, rootURL, routes) => {
  const path = createResourceLocatorString(
    'StripePayoutOnboardingPage',
    routes,
    { returnURLType },
    {}
  );
  const root = rootURL.replace(/\/$/, '');
  return `${root}${path}`;
};

// const { UUID } = sdkTypes;
// Get attribute: stripeAccountData
const getStripeAccountData = stripeAccount => stripeAccount.attributes.stripeAccountData || null;

// Get last 4 digits of bank account returned in Stripe account
const getBankAccountLast4Digits = stripeAccountData =>
  stripeAccountData && stripeAccountData.external_accounts.data.length > 0
    ? stripeAccountData.external_accounts.data[0].last4
    : null;

// Check if there's requirements on selected type: 'past_due', 'currently_due' etc.
const hasRequirements = (stripeAccountData, requirementType) =>
  stripeAccountData != null &&
  stripeAccountData.requirements &&
  Array.isArray(stripeAccountData.requirements[requirementType]) &&
  stripeAccountData.requirements[requirementType].length > 0;

// Redirect user to Stripe's hosted Connect account onboarding form
const handleGetStripeConnectAccountLinkFn = (getLinkFn, commonParams) => type => () => {
  getLinkFn({ type, ...commonParams })
    .then(url => {
      window.location.href = url;
    })
    .catch(err => console.error(err));
};

export const StripePayoutPageComponent = props => {
  const {
    currentUser,
    // scrollingDisabled,
    getAccountLinkInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccountFetched,
    stripeAccount,
    onPayoutDetailsFormChange,
    onPayoutDetailsFormSubmit,
    onGetStripeConnectAccountLink,
    payoutDetailsSaveInProgress,
    payoutDetailsSaved,
    params,
    intl,
    // history,
    // location,
    onFetchCurrentUser,
    onRemoveSubscription,
    onReactivateSubscription,
    onCheckProfileCompleted,
    onFetchPortalSession,
  } = props;

  const [value, setValue] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [valuetabIndex, setValuetabIndex] = useState(false);

  // ---- Early-member eligibility ----
  // Eligibility is owned by the backend (subscription-service /eligible-plans).
  // It returns the list of Chargebee plan IDs the coach can subscribe to,
  // based on the coach's Sharetribe `createdAt` and the GRANDFATHER_CUTOFF_DATE
  // env var. If the coach signed up before the cutoff, the response includes
  // `First-Mover-Network-Monthly` ($9.50/mo), `First-Mover-Network-Annual`,
  // and `Legacy-Subscriber---Lifetime` (Viveka First 100 at $997 one-time).
  //
  // The frontend never inspects the cutoff date directly. We just call the
  // endpoint and render conditionally on what comes back. The /checkout
  // endpoint re-validates eligibility server-side on submit, so a crafted
  // request can't bypass the gate.
  const [lifetimeSeats, setLifetimeSeats] = useState(null); // { seatsSold, seatLimit, seatsRemaining }

  // Billing cycle toggle for the First Mover panel. Monthly is default
  // (it carries the 7-day free trial). Switching to annual swaps prices,
  // plan IDs, and CTA copy on the Network and Verified cards. Lifetime
  // is unaffected — it has no period.
  const [isAnnual, setIsAnnual] = useState(false);

  // Cancellation flow lives entirely in the Chargebee customer portal that
  // opens via the Manage Subscription button. We tried building a native
  // confirm modal + cancel button on this page (May 7) but it duplicated
  // what Chargebee already does well, so we reverted to portal-only cancel.
  // What we DO keep on this page is:
  //   - the "Cancellation scheduled" badge (useful regardless of which UI
  //     the coach used to cancel — it shows at-a-glance status)
  //   - the Reactivate Subscription button (one-click un-schedule of the
  //     pending cancellation, talks to /chargebee/reactivate-subscription)
  //   - the SubscriptionExpiryBanner that renders on every dashboard page
  //     when a coach has < 7 days of access remaining or has a cancellation
  //     scheduled (lives in MainDashboardWrapper, not this file)

  // Reactivation flow — when a coach has already scheduled a cancellation
  // (`subscriptionCancellation` on metadata) we show a "Reactivate
  // Subscription" button that un-schedules the cancellation in Chargebee
  // (status flips back from non_renewing to active) and clears the
  // Sharetribe flag. One-click action; no confirm modal — reactivation
  // is a non-destructive action and we don't want to friction-gate
  // someone who's having second thoughts about leaving.
  const [reactivating, setReactivating] = useState(false);
  const [reactivateError, setReactivateError] = useState(null);

  // Fetch the live Lifetime seat count from the backend. Eligibility itself
  // is computed client-side (see isLegacyEligible below) from createdAt vs
  // config.firstMoverCutoffDate, so the correct panel renders on first paint
  // with no round-trip. We still hit /eligible-plans here for the seat count
  // because that's real backend state. The /checkout endpoint validates
  // eligibility server-side on submit, so this client-side check is purely
  // for UI rendering — it can't be exploited.
  useEffect(() => {
    const userId = currentUser && currentUser.id && currentUser.id.uuid;
    const createdAt = currentUser && currentUser.attributes && currentUser.attributes.createdAt;
    if (!userId || !createdAt) return;

    axios
      .post(`${config.subscriptionServiceUrl}eligible-plans`, { createdAt }, {
        headers: { 'content-type': 'application/json' },
      })
      .then(res => {
        if (res.data && res.data.lifetime) {
          setLifetimeSeats(res.data.lifetime);
        }
      })
      .catch(err => {
        console.error('[pricing] eligible-plans error:', err && err.message);
      });
  }, [currentUser && currentUser.id && currentUser.id.uuid]);

  // Standard plan IDs (everyone sees these). Match Chargebee plan IDs
  // registered in subscription-service/scripts/plans.js.
  const STD_NETWORK_PLAN_ID = 'Network-Member---Monthly';
  const STD_NETWORK_ANNUAL_PLAN_ID = 'Network-Member-Annual';
  const STD_VERIFIED_PLAN_ID = 'Verified-Coach-Monthly';
  const STD_VERIFIED_ANNUAL_PLAN_ID = 'Verified-Coach---Annual';
  // First Mover plan IDs (only offered when the backend says the user
  // qualifies — i.e. account created before GRANDFATHER_CUTOFF_DATE).
  const FM_NETWORK_PLAN_ID = 'First-Mover-Network-Monthly';
  const FM_NETWORK_ANNUAL_PLAN_ID = 'First-Mover-Network-Annual';
  const FM_VERIFIED_PLAN_ID = 'First-Mover-Verified-Monthly';
  const FM_VERIFIED_ANNUAL_PLAN_ID = 'First-Mover-Verified-Annual';
  const FM_LIFETIME_PLAN_ID = 'Legacy-Subscriber---Lifetime';
  // Active plan IDs swap between monthly and annual based on the toggle.
  // Used by the Network and Verified cards. Lifetime has no period swap.
  const activeFmNetworkPlanId = isAnnual ? FM_NETWORK_ANNUAL_PLAN_ID : FM_NETWORK_PLAN_ID;
  const activeFmVerifiedPlanId = isAnnual ? FM_VERIFIED_ANNUAL_PLAN_ID : FM_VERIFIED_PLAN_ID;
  const activeStdNetworkPlanId = isAnnual ? STD_NETWORK_ANNUAL_PLAN_ID : STD_NETWORK_PLAN_ID;
  const activeStdVerifiedPlanId = isAnnual ? STD_VERIFIED_ANNUAL_PLAN_ID : STD_VERIFIED_PLAN_ID;

  // Eligibility is computed client-side from createdAt vs the cutoff env
  // var. This is what eliminates the panel flash for legacy coaches — no
  // network round-trip required to pick the right UI. The backend
  // (subscription-service/scripts/plans.js) is still the source of truth
  // and re-validates on /checkout, so a crafted request can't bypass.
  const isLegacyEligible = (() => {
    const cutoff = config.firstMoverCutoffDate;
    const createdAt = currentUser && currentUser.attributes && currentUser.attributes.createdAt;
    if (!cutoff || !createdAt) return false;
    return new Date(createdAt) < new Date(cutoff);
  })();

  // Plan IDs the on-card buttons should target. Eligible coaches subscribe
  // to First Mover SKUs; everyone else gets standard SKUs. The view switch
  // is in the JSX below — eligible users see the thank-you panel, non-
  // eligible users see the standard 2-card layout.
  const LEGACY_LIFETIME_PLAN_ID = FM_LIFETIME_PLAN_ID;

  // Lifetime seat counter (hydrated from /eligible-plans response).
  const lifetimeSeatsRemaining =
    lifetimeSeats && typeof lifetimeSeats.seatsRemaining === 'number'
      ? lifetimeSeats.seatsRemaining
      : null;
  const lifetimeSeatLimit =
    lifetimeSeats && typeof lifetimeSeats.seatLimit === 'number'
      ? lifetimeSeats.seatLimit
      : 100;
  console.log(tabIndex);
  // const [chargeBeeLoading, setChargeBeeLoading] = useState(false);

  // const [chargebeeRes, setChargebeeRes] = useState({});
  // const [iframeEnabled, setIframeEnabled] = useState(false);

  const { returnURLType, tab } = params;

  // console.log('****' + returnURLType);
  // console.log('****' + tab);

  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const currentUserLoaded = !!ensuredCurrentUser.id;
  const stripeConnected = currentUserLoaded && !!stripeAccount && !!stripeAccount.id;

  // const title = intl.formatMessage({ id: 'StripePayoutPage.title' });

  const formDisabled = getAccountLinkInProgress;

  const rootURL = config.canonicalRootURL;
  const routes = routeConfiguration();
  const successURL = createReturnURL(STRIPE_ONBOARDING_RETURN_URL_SUCCESS, rootURL, routes);
  const failureURL = createReturnURL(STRIPE_ONBOARDING_RETURN_URL_FAILURE, rootURL, routes);

  const accountId = stripeConnected ? stripeAccount.id : null;
  const stripeAccountData = stripeConnected ? getStripeAccountData(stripeAccount) : null;
  const requirementsMissing =
    stripeAccount &&
    (hasRequirements(stripeAccountData, 'past_due') ||
      hasRequirements(stripeAccountData, 'currently_due'));

  const savedCountry = stripeAccountData ? stripeAccountData.country : null;

  const handleGetStripeConnectAccountLink = handleGetStripeConnectAccountLinkFn(
    onGetStripeConnectAccountLink,
    {
      accountId,
      successURL,
      failureURL,
    }
  );

  const returnedNormallyFromStripe = returnURLType === STRIPE_ONBOARDING_RETURN_URL_SUCCESS;
  const showVerificationError = returnURLType === STRIPE_ONBOARDING_RETURN_URL_FAILURE;
  const showVerificationNeeded = stripeConnected && requirementsMissing;

  // Redirect from success URL to basic path for StripePayoutPage
  if (returnedNormallyFromStripe && stripeConnected && !requirementsMissing) {
    return <NamedRedirect name="StripePayoutPage" />;
  }

  // function payMemberShipFee() {
  //   alert('pay your membership Fee');
  // }

  // const handleBookingSubmit = values => {
  //   //const {  history , location } = props;
  //
  //   const { params, callSetInitialValues, onInitializeCardPaymentData } = props;
  //
  //   const paymentPlan = 'classic';
  //   const timePeriod = 'monthly';
  //   const price = '70';
  //
  //   const initialValues = {
  //     paymentPlan,
  //     timePeriod,
  //     price,
  //   };
  //
  //   /*
  //   const routes = routeConfiguration();
  //   //Customize checkout page state with current listing and selected bookingDates
  //   const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);
  //   callSetInitialValues(setInitialValues, initialValues);
  //
  //   //Clear previous Stripe errors from store if there is any
  //   onInitializeCardPaymentData();
  //
  //   //Redirect to CheckoutPage
  //   console.log(routes);
  //   console.log(props);
  //
  //   const history = createHashHistory();
  //
  //   console.log(history);
  //
  //   history.push(
  //     createResourceLocatorString(
  //       'CheckoutPage',
  //       routes,
  //       { id: "5e639cf9-1774-43e0-bf15-d6bea5c43ffa", slug: createSlug("payment") },
  //       {}
  //     )
  //   );
  //   */
  // };
  // let simpleDialog;

  // const ChargeBeeComponent = () => {
  //   const url = chargebeeRes.data && chargebeeRes.data.hosted_page.url;
  //
  //   return (
  //     iframeEnabled && (
  //       <iframe style={{ border: 'none' }} src={url} height="100%" width="100%"></iframe>
  //     )
  //   );
  // };

  // const getPlanStr = () => {
  //   if (value && showClassicSelected) {
  //     return 'annual-membership-fee';
  //   }

  //   if (!value && showClassicSelected) {
  //     // return 'classic-monthly'
  //     return 'viveka-monthly-membership-fee';
  //   }

  //   if (value && showPremiumSelected) {
  //     return 'premium-membership';
  //   }

  //   if (!value && showPremiumSelected) {
  //     // return 'premium-monthly'
  //     return 'monthly_preferred-membership';
  //   }
  // };

  // const onPayment = plan => {
  //   setIframeEnabled(true);
  //   // console.log(ensuredCurrentUser);
  //   const subscriptionId =
  //     ensuredCurrentUser.attributes.profile.metadata &&
  //     ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails &&
  //     ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails.subscriptionId;
  //
  //   const model = simpleDialog;
  //
  //   const email = ensuredCurrentUser.attributes.email;
  //   // const plan = getPlanStr();
  //
  //   // console.log(config.subscriptionServiceUrl);
  //
  //   // console.log('plan', getPlanStr());
  //   const params = subscriptionId
  //     ? {
  //       email: email,
  //       plan: plan,
  //       subscriptionId: subscriptionId,
  //     }
  //     : {
  //       email: email,
  //       plan: plan,
  //     };
  //
  //   setChargeBeeLoading(true);
  //   axios
  //     .post(`${config.subscriptionServiceUrl}checkout`, params, {
  //       headers: {
  //         'content-type': 'application/json',
  //       },
  //     })
  //     .then(res => {
  //       setChargeBeeLoading(false);
  //       console.log(res);
  //       setChargebeeRes(res);
  //       model.show();
  //     })
  //     .catch(err => {
  //       setChargeBeeLoading(false);
  //       console.log(err);
  //     });
  // };

  // const modelStyle =
  //   window.outerWidth > 650
  //     ? {
  //       top: '0px',
  //       height: '100vh',
  //       marginTop: '0'
  //
  //     }
  //     : {
  //       width: 'auto',
  //       marginTop: '0',
  //       marginLeft: 0,
  //       minHeight: '100px',
  //       top: '50px',
  //       left: '20px',
  //       right: '20px',
  //       height: '90vh',
  //     };

  const getSubscriptionType = () => {
    return (
      ensuredCurrentUser.attributes.profile.metadata &&
      ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails &&
      ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails.subscriptionName
    );
  };
  const subscription =  ensuredCurrentUser?.attributes?.profile?.metadata?.subscriptionDetails?.subscription

  // Opens the Chargebee customer portal where users can update their card,
  // view invoices, change plan, and cancel/resume their subscription.
  // Backed by /chargebee/portal-session in subscription-service.
  function openManageSubscription() {
    const Chargebee = window.Chargebee;
    const chargebeeInstance = Chargebee.init({
      site: config.chargebeeSiteName,
    });

    chargebeeInstance.setPortalSession(() => {
      return onFetchPortalSession();
    });

    const cbPortal = chargebeeInstance.createChargebeePortal();
    cbPortal.open({
      close: () => {
        // Refresh the user record so any plan / cancellation changes the user
        // made inside the portal show up immediately on the pricing page.
        sleep(2000).then(() => {
          onFetchCurrentUser();
        });
      },
    });
  }

  function openChargebeePortal(plan) {
    const Chargebee = window.Chargebee;
    const chargebeeInstance = Chargebee.init({
      site: config.chargebeeSiteName,
    });
    chargebeeInstance.openCheckout({
      hostedPage: () => {
        return new Promise(function(resolve, reject) {
          const subscriptionId =
            ensuredCurrentUser.attributes.profile.metadata &&
            ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails &&
            ensuredCurrentUser.attributes.profile.metadata.subscriptionDetails.subscriptionId;

          const email = ensuredCurrentUser.attributes.email;

          const flexUserUUID =
            ensuredCurrentUser && ensuredCurrentUser.id && ensuredCurrentUser.id.uuid;

          // createdAt is required by the backend /checkout endpoint to
          // re-validate eligibility for legacy plans. Without it, the
          // backend rejects requests for Legacy-Subscriber-* plans.
          const createdAt =
            ensuredCurrentUser &&
            ensuredCurrentUser.attributes &&
            ensuredCurrentUser.attributes.createdAt;

          const params = subscriptionId
            ? {
                email: email,
                plan: plan,
                flexUserUUID,
                subscriptionId: subscriptionId,
                createdAt,
              }
            : {
                email: email,
                plan: plan,
                flexUserUUID,
                createdAt,
              };
          // console.log(params);
          axios
            .post(`${config.subscriptionServiceUrl}checkout`, params, {
              headers: {
                'content-type': 'application/json',
              },
            })
            .then(res => {
              resolve(res.data.hosted_page);
            })
            .catch(err => {
              console.log(err);
              reject(err);
            });
        });
      },
      close: () => {
        sleep(7000).then(() => {
          onFetchCurrentUser();
          onCheckProfileCompleted();
          console.log('current user refreshed');
        });
      },
    });
  }

  // const pubData = currentUser && currentUser.attributes.profile.publicData;
  // const isProvider = pubData && !!pubData.isProvider;

  // if (!isProvider === true){
  //   history && history.push('/profile-settings')
  // }

  // if (!isProvider === true){
  //   history && history.push('/account/payments/withdrawal')
  // }

  const validTab = tab === 'withdrawal';
  if (validTab && !valuetabIndex) {
    setTabIndex(1);
    setValuetabIndex(true);
    return;
  }

  const validPricingTab = tab === 'pricing';
  if (validPricingTab && !valuetabIndex) {
    setTabIndex(0);
    setValuetabIndex(true);
    return;
  }

  const getSubscriptionName = subscriptionAlias => {
    switch (subscriptionAlias) {
      // ── Current Chargebee plans ───────────────────────
      case 'Network-Member---Monthly':
        return 'Network Member - Monthly';
      case 'Network-Member-Annual':
        return 'Network Member - Annual';
      case 'Verified-Coach-Monthly':
        return 'Verified Coach - Monthly';
      case 'Verified-Coach---Annual':
        return 'Verified Coach - Annual';
      case 'First-Mover-Network-Monthly':
        return 'First Mover Network - Monthly';
      case 'First-Mover-Network-Annual':
        return 'First Mover Network - Annual';
      case 'First-Mover-Verified-Monthly':
        return 'First Mover Verified - Monthly';
      case 'First-Mover-Verified-Annual':
        return 'First Mover Verified - Annual';
      case 'Legacy-Subscriber---Lifetime':
        return 'First Mover Lifetime';
      // ── Legacy plan IDs (existing subscribers — display only) ─
      case 'viveka-network-monthly':
      case 'viveka-monthly-membership-fee':
        return 'Viveka Network - Monthly';
      case 'annual-membership-fee':
        return 'Viveka Network - Annual';
      case 'viveka-verified-monthly':
      case 'monthly_preferred-membership':
        return 'Viveka Verified Coach - Monthly';
      case 'premium-membership':
        return 'Viveka Verified Coach - Annual';
      default:
        return 'N/A';
    }
  };

  // Cancellation now happens via the Chargebee customer portal (Manage
  // Subscription button → portal iframe → cancel within the portal flow).
  // Kept for any legacy callers, but no UI element invokes this directly.
  const onRemoveButtonClick = () => {
    if (window.confirm('This will cancel the subscription and remove your token, are you sure?')) {
      onRemoveSubscription();
    }
  };

  // One-click reactivation. Calls the existing onReactivateSubscription
  // dispatch (POST /chargebee/reactivate-subscription) which unschedules
  // the cancellation in Chargebee + clears subscriptionCancellation in
  // Sharetribe + re-fetches currentUser. After it resolves the badge
  // disappears and the Cancel button re-appears.
  const onReactivateClick = async () => {
    if (reactivating) return;
    setReactivating(true);
    setReactivateError(null);
    try {
      await onReactivateSubscription();
    } catch (e) {
      setReactivateError('Sorry, we couldn\'t reactivate your subscription. Please try again or contact support.');
    } finally {
      setReactivating(false);
    }
  };

  const subscriptionCancellation =
    ensuredCurrentUser?.attributes?.profile?.metadata?.subscriptionCancellation;
  const subscriptionDetails =
    ensuredCurrentUser?.attributes?.profile?.metadata?.subscriptionDetails;
  // Lifetime subscribers are non-cancellable per Subscription Gating
  // Spec §5.4. Detected via the `isLifetime` flag the webhook writes
  // (subscription.js → updateUser sets isLifetime: true for the
  // Legacy-Subscriber---Lifetime plan), with a planId fallback for
  // resilience against backfilled / legacy metadata that may not have
  // the flag yet.
  const isLifetimeSubscriber =
    !!(subscriptionDetails &&
      (subscriptionDetails.isLifetime === true ||
        subscriptionDetails.planId === 'Legacy-Subscriber---Lifetime'));

  return (
    <PageWrapper>
      <MainDashboardWrapper title={'Settings'} page={'all-setting'}>
        {/* {tab === 'pricing' ?  */}
        <div className={css.wrapper}>
          {tab === 'pricing' ? (
            <SettingsLayoutWrapper page="payments">
              {/* <DashboardPaymentsWrapper /> */}
              {/* <ContainerWrapper> */}
              <div className={css.outerbase}>
                {/*<div className={classnames(css.row, css.titleRow)}>*/}
                {/*  <div className={css.leftDivDes}>*/}
                {/*    <p>*/}
                {/*      Your success is our success. Your business is our business. We'll help you*/}
                {/*      make the right choice for your business & life.*/}
                {/*    </p>*/}
                {/*  </div>*/}
                {/*  <div className={css.rightDivDes}>*/}
                {/*    <p>*/}
                {/*      To us, you are more than just a number. When you join Viveka, you immediately*/}
                {/*      become part of our extended family. As one of our exclusive coaches, you'll*/}
                {/*      receive tools and trainings to help you grow. We are here to help you amplify*/}
                {/*      your success in your business, so you can focus on what you do best. One of*/}
                {/*      the signature tools is our proprietary matching technology where you'll*/}
                {/*      automatically be matched with the right potential clients – making it even*/}
                {/*      easier for you to secure your next client. And we provide exclusive trainings*/}
                {/*      to help you continue your growth both professionally AND personally. Because*/}
                {/*      at Viveka, we believe you don't have to compromise your life to succeed. You*/}
                {/*      can have it all!*/}
                {/*    </p>*/}
                {/*  </div>*/}
                {/*</div>*/}

                {/*<div className={css.specialOffer}>
                  <p>Apply coupon code: 30%LAUNCHSPECIAL</p>
                  <img alt="Special offer" src={Offer} />
                </div>*/}
                <p>
                  Built for coaches who want more than a directory listing.
                  Operate within a network that connects coaching to real opportunities.
                </p>

                {/*
                  Subscription management toolbar. Visible only to users who
                  already have a subscription (subscriptionDetails on
                  metadata). Two actions:

                    Manage Subscription — opens the Chargebee customer
                      portal in an iframe overlay (payment method,
                      invoices, billing history).

                    Cancel Subscription — opens our native Viveka-branded
                      confirmation modal and calls /chargebee/remove-
                      subscription with end_of_term: true. The user keeps
                      access until the period they paid for actually ends;
                      after that, the subscription_cancelled webhook fires
                      and `subscriptionDetails` gets nulled.

                  We also render a "Cancellation scheduled" badge when
                  `subscriptionCancellation` is on metadata, so users
                  understand their cancel went through (instead of seeing
                  "Current" until end-of-term and assuming it failed).
                */}
                {/* Lifetime subscribers get a friendly notice above the
                    toolbar reminding them their plan doesn't renew or
                    expire (spec §5.4). The Manage Subscription button
                    is still useful for updating payment method, so we
                    keep the toolbar — Chargebee admin disables the
                    Cancel button inside the customer portal per spec
                    §5.4 step 1. */}
                {isLifetimeSubscriber && (
                  <div
                    role="region"
                    aria-label="Lifetime access notice"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      padding: '16px 18px',
                      marginBottom: '14px',
                      borderRadius: '12px',
                      background:
                        'linear-gradient(90deg, rgba(251, 191, 36, 0.16) 0%, rgba(251, 191, 36, 0.06) 100%)',
                      border: '1px solid rgba(251, 191, 36, 0.55)',
                      color: '#0F172A',
                      flexWrap: 'wrap',
                    }}
                  >
                    <span aria-hidden="true" style={{ fontSize: '22px', lineHeight: 1 }}>
                      ✨
                    </span>
                    <div style={{ flex: '1 1 auto', minWidth: '240px' }}>
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: '15px',
                          marginBottom: '2px',
                        }}
                      >
                        You have lifetime access to Verified Coach
                      </div>
                      <div style={{ fontSize: '13px', lineHeight: 1.5, color: '#334155' }}>
                        Your subscription doesn't renew and won't
                        expire. If you need to update your payment
                        method, use Manage Subscription. For anything
                        else,{' '}
                        <a
                          href="mailto:support@viveka.world"
                          style={{ color: '#0F766E', fontWeight: 600 }}
                        >
                          contact support
                        </a>
                        .
                      </div>
                    </div>
                  </div>
                )}

                {subscriptionDetails && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      gap: '12px',
                      flexWrap: 'wrap',
                      marginBottom: '16px',
                    }}
                  >
                    {subscriptionCancellation && !isLifetimeSubscriber && (
                      <div
                        style={{
                          padding: '6px 12px',
                          borderRadius: '999px',
                          background: 'rgba(245, 158, 11, 0.12)',
                          border: '1px solid rgba(245, 158, 11, 0.5)',
                          color: '#B45309',
                          fontSize: '12px',
                          fontWeight: 700,
                          letterSpacing: '0.04em',
                          textTransform: 'uppercase',
                        }}
                        title="Your subscription is set to end at the end of the current billing period."
                      >
                        Cancellation scheduled
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={() => openManageSubscription()}
                      style={{
                        background: 'transparent',
                        border: '1px solid var(--marketplaceColorMid, #14B8A6)',
                        color: 'var(--marketplaceColorMid, #14B8A6)',
                        borderRadius: '5px',
                        padding: '8px 16px',
                        fontSize: '14px',
                        fontWeight: 500,
                        cursor: 'pointer',
                      }}
                    >
                      Manage Subscription
                    </button>

                    {/*
                      Reactivate button — one-click un-schedule of a pending
                      cancellation. Only visible when subscriptionCancellation
                      is on metadata. Cancellation itself is initiated from
                      the Chargebee customer portal that opens via the Manage
                      Subscription button above.

                      Hidden for Lifetime subscribers — they can't have a
                      scheduled cancellation in the first place (spec §5.4).
                    */}
                    {subscriptionCancellation && !isLifetimeSubscriber && (
                      <button
                        type="button"
                        onClick={onReactivateClick}
                        disabled={reactivating}
                        title="Cancel the scheduled cancellation. Your subscription will continue renewing as normal."
                        style={{
                          background: '#10B981',
                          border: '1px solid #10B981',
                          color: '#FFFFFF',
                          borderRadius: '5px',
                          padding: '8px 16px',
                          fontSize: '14px',
                          fontWeight: 600,
                          cursor: reactivating ? 'wait' : 'pointer',
                          opacity: reactivating ? 0.7 : 1,
                          transition: 'background 0.15s ease, transform 0.15s ease',
                        }}
                        onMouseEnter={(e) => {
                          if (reactivating) return;
                          e.currentTarget.style.background = '#059669';
                          e.currentTarget.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#10B981';
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        {reactivating ? 'Reactivating…' : 'Reactivate Subscription'}
                      </button>
                    )}

                    {/* Reactivation error toast (inline, next to the buttons). */}
                    {reactivateError && (
                      <div
                        style={{
                          width: '100%',
                          padding: '8px 12px',
                          borderRadius: '6px',
                          background: 'rgba(220, 38, 38, 0.08)',
                          border: '1px solid rgba(220, 38, 38, 0.4)',
                          color: '#991B1B',
                          fontSize: '13px',
                          marginTop: '6px',
                        }}
                      >
                        {reactivateError}
                      </div>
                    )}
                  </div>
                )}

                {!currentUserLoaded ? (
                  /*
                    ── Loading placeholder ────────────────────────────
                    Only renders on a truly cold first load before the
                    Sharetribe currentUser fetch resolves. Once user is
                    in redux state (any subsequent navigation), the
                    correct panel renders on first paint because
                    isLegacyEligible is computed client-side from
                    createdAt + config.firstMoverCutoffDate.
                    Match approximate panel dimensions to avoid CLS.
                  */
                  <div
                    style={{
                      marginTop: '8px',
                      padding: '60px 32px',
                      borderRadius: '20px',
                      background: 'linear-gradient(180deg, rgba(30,16,64,0.04) 0%, rgba(30,16,64,0.02) 100%)',
                      border: '1px solid rgba(139,92,246,0.08)',
                      minHeight: '420px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'rgba(30,16,64,0.4)',
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontSize: '14px',
                      fontWeight: 500,
                      letterSpacing: '0.05em',
                    }}
                  >
                    Loading subscription options…
                  </div>
                ) : isLegacyEligible ? (
                  /*
                    ── First Mover thank-you panel ────────────────────
                    Eligible coaches (Sharetribe createdAt < May 1, 2026)
                    see ONLY this panel — not the standard $19/$49 cards.
                    For them, the offer is the First Mover rate, not a
                    discount. Three options: discounted Network, Lifetime
                    (centered + dominant), discounted Verified.
                  */
                  <div
                    style={{
                      marginTop: '8px',
                      padding: '36px 32px',
                      borderRadius: '20px',
                      background: 'linear-gradient(180deg, #1E1040 0%, #3B0764 100%)',
                      color: '#fff',
                      boxShadow: '0 30px 80px -25px rgba(30,16,64,0.55)',
                    }}
                  >
                    <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 28px' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontWeight: 700,
                          fontSize: '11px',
                          letterSpacing: '0.18em',
                          textTransform: 'uppercase',
                          color: '#1E1040',
                          background: '#FBBF24',
                          padding: '6px 14px',
                          borderRadius: '999px',
                          marginBottom: '20px',
                        }}
                      >
                        First Mover · Thank You
                      </div>
                      <h2
                        style={{
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontWeight: 800,
                          fontSize: '28px',
                          lineHeight: 1.2,
                          color: '#fff',
                          margin: '0 0 14px',
                          letterSpacing: '-0.02em',
                        }}
                      >
                        Thank you for joining Viveka before we relaunched.
                      </h2>
                      <p style={{ fontSize: '15px', color: '#C4B5FD', lineHeight: 1.65, margin: 0 }}>
                        You held a place in the network from the beginning. As a First Mover, your First Mover rate is yours to lock in. Monthly and annual rates close <strong style={{ color: '#FBBF24' }}>August 31, 2026</strong>. Lifetime is reserved for the Viveka First 100{lifetimeSeatsRemaining !== null ? ' — ' + lifetimeSeatsRemaining + ' of ' + lifetimeSeatLimit + ' seats remaining' : ''}.
                      </p>
                    </div>

                    {/* Monthly / Annual billing cycle toggle */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                      <div
                        role="tablist"
                        aria-label="Billing cycle"
                        style={{
                          display: 'inline-flex',
                          background: 'rgba(255,255,255,0.05)',
                          border: '1px solid rgba(192,132,252,0.2)',
                          borderRadius: '999px',
                          padding: '4px',
                        }}
                      >
                        <button
                          type="button"
                          role="tab"
                          aria-selected={!isAnnual}
                          onClick={() => setIsAnnual(false)}
                          style={{
                            background: !isAnnual ? '#FBBF24' : 'transparent',
                            color: !isAnnual ? '#1E1040' : 'rgba(255,255,255,0.7)',
                            border: 'none',
                            padding: '8px 22px',
                            borderRadius: '999px',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.04em',
                            cursor: 'pointer',
                            transition: 'all .2s ease',
                          }}
                        >
                          Monthly
                        </button>
                        <button
                          type="button"
                          role="tab"
                          aria-selected={isAnnual}
                          onClick={() => setIsAnnual(true)}
                          style={{
                            background: isAnnual ? '#FBBF24' : 'transparent',
                            color: isAnnual ? '#1E1040' : 'rgba(255,255,255,0.7)',
                            border: 'none',
                            padding: '8px 22px',
                            borderRadius: '999px',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.04em',
                            cursor: 'pointer',
                            transition: 'all .2s ease',
                          }}
                        >
                          Annual
                        </button>
                      </div>
                    </div>

                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))',
                        gap: '16px',
                        alignItems: 'stretch',
                        maxWidth: '900px',
                        margin: '0 auto',
                      }}
                    >
                      <div
                        style={{
                          background: 'rgba(255,255,255,0.05)',
                          border: '1px solid rgba(192,132,252,0.25)',
                          borderRadius: '14px',
                          padding: '28px 24px',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#C084FC', marginBottom: '12px' }}>
                          Network Member
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '34px', color: '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          {isAnnual ? '$98.50' : '$9.50'}<span style={{ fontSize: '14px', fontWeight: 500, color: '#A78BFA' }}>{isAnnual ? '/year' : '/mo'}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#FBBF24', marginTop: '6px', fontWeight: 500 }}>
                          {isAnnual ? 'First Mover rate locked for as long as you stay subscribed' : '7-day free trial · standard $19/mo'}
                        </div>
                        <ul style={{ margin: '20px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '13px', lineHeight: 1.6, color: '#E9D5FF' }}>
                          <li style={{ padding: '4px 0' }}>Professional coaching profile in the Viveka marketplace</li>
                          <li style={{ padding: '4px 0' }}>Practice management tools — scheduling, accountability, programs, ads</li>
                          <li style={{ padding: '4px 0' }}>Monthly coaching industry insights</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => openChargebeePortal(activeFmNetworkPlanId)}
                          disabled={getSubscriptionType() === activeFmNetworkPlanId}
                          style={{
                            background: 'transparent',
                            color: '#fff',
                            border: '1px solid rgba(255,255,255,0.4)',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '14px',
                            cursor: getSubscriptionType() === activeFmNetworkPlanId ? 'default' : 'pointer',
                            opacity: getSubscriptionType() === activeFmNetworkPlanId ? 0.5 : 1,
                          }}
                        >
                          {getSubscriptionType() === activeFmNetworkPlanId ? 'Current' : (isAnnual ? 'Subscribe Annually' : (subscription ? 'Switch to Network' : 'Start 7-Day Free Trial'))}
                        </button>
                        <div style={{ fontSize: '11px', color: '#A78BFA', textAlign: 'center', marginTop: '8px' }}>
                          {(subscription || isAnnual) ? '\u00A0' : 'No charge for 7 days. Cancel anytime.'}
                        </div>
                      </div>

                      <div
                        style={{
                          background: 'rgba(251,191,36,0.08)',
                          border: '1px solid rgba(251,191,36,0.35)',
                          borderRadius: '14px',
                          padding: '32px 24px',
                          display: 'flex',
                          flexDirection: 'column',
                          position: 'relative',
                          marginTop: '4px',
                        }}
                      >
                        <div
                          style={{
                            position: 'absolute',
                            top: '-12px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            background: '#FBBF24',
                            color: '#1E1040',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontWeight: 700,
                            fontSize: '11px',
                            letterSpacing: '0.14em',
                            textTransform: 'uppercase',
                            padding: '5px 14px',
                            borderRadius: '999px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          Viveka First 100
                        </div>
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#FBBF24', marginBottom: '10px', marginTop: '8px' }}>
                          Verified Coach — Lifetime
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '44px', color: '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          $997<span style={{ fontSize: '14px', fontWeight: 500, color: '#FBBF24', marginLeft: '8px' }}>one-time</span>
                        </div>
                        <div style={{ fontSize: '13px', color: '#FBBF24', marginTop: '8px', fontWeight: 500 }}>
                          Equivalent to $49/month today · locked in for life
                        </div>
                        <ul style={{ margin: '18px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '14px', lineHeight: 1.6, color: '#E9D5FF' }}>
                          <li style={{ padding: '4px 0' }}>Lifetime Verified Coach status — locked permanently</li>
                          <li style={{ padding: '4px 0' }}>Priority visibility across the network</li>
                          <li style={{ padding: '4px 0' }}>No renewals. No future price increases.</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => openChargebeePortal(FM_LIFETIME_PLAN_ID)}
                          disabled={getSubscriptionType() === FM_LIFETIME_PLAN_ID}
                          style={{
                            background: '#FBBF24',
                            color: '#1E1040',
                            border: 'none',
                            padding: '14px 24px',
                            borderRadius: '10px',
                            fontWeight: 700,
                            fontSize: '15px',
                            cursor: getSubscriptionType() === FM_LIFETIME_PLAN_ID ? 'default' : 'pointer',
                            opacity: getSubscriptionType() === FM_LIFETIME_PLAN_ID ? 0.5 : 1,
                          }}
                        >
                          {getSubscriptionType() === FM_LIFETIME_PLAN_ID ? 'Current — Lifetime' : 'Lock In Lifetime Access'}
                        </button>
                        {lifetimeSeatsRemaining !== null && (
                          <div style={{ fontSize: '12px', color: '#A78BFA', textAlign: 'center', marginTop: '10px' }}>
                            {lifetimeSeatsRemaining} of {lifetimeSeatLimit} seats remaining
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          background: 'rgba(255,255,255,0.05)',
                          border: '1px solid rgba(192,132,252,0.25)',
                          borderRadius: '14px',
                          padding: '28px 24px',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#C084FC', marginBottom: '12px' }}>
                          {isAnnual ? 'Verified Coach — Annual' : 'Verified Coach — Monthly'}
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '34px', color: '#fff', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          {isAnnual ? '$248.50' : '$24.50'}<span style={{ fontSize: '14px', fontWeight: 500, color: '#A78BFA' }}>{isAnnual ? '/year' : '/mo'}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#FBBF24', marginTop: '6px', fontWeight: 500 }}>
                          {isAnnual ? 'First Mover rate locked for as long as you stay subscribed' : '7-day free trial · standard $49/mo'}
                        </div>
                        <ul style={{ margin: '20px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '13px', lineHeight: 1.6, color: '#E9D5FF' }}>
                          <li style={{ padding: '4px 0' }}>Viveka Verification badge with priority placement on Marketplace Ads</li>
                          <li style={{ padding: '4px 0' }}>Eligibility for enterprise engagements and Viveka spotlight features</li>
                          <li style={{ padding: '4px 0' }}>Reporting and analytics, file uploads, and 10 active listings</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => openChargebeePortal(activeFmVerifiedPlanId)}
                          disabled={getSubscriptionType() === activeFmVerifiedPlanId}
                          style={{
                            background: 'transparent',
                            color: '#fff',
                            border: '1px solid rgba(255,255,255,0.4)',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '14px',
                            cursor: getSubscriptionType() === activeFmVerifiedPlanId ? 'default' : 'pointer',
                            opacity: getSubscriptionType() === activeFmVerifiedPlanId ? 0.5 : 1,
                          }}
                        >
                          {getSubscriptionType() === activeFmVerifiedPlanId ? 'Current' : (isAnnual ? 'Subscribe Annually' : (subscription ? 'Switch to Verified' : 'Start 7-Day Free Trial'))}
                        </button>
                        <div style={{ fontSize: '11px', color: '#A78BFA', textAlign: 'center', marginTop: '8px' }}>
                          {(subscription || isAnnual) ? '\u00A0' : 'No charge for 7 days. Cancel anytime.'}
                        </div>
                      </div>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '24px', fontSize: '12px', color: '#A78BFA', lineHeight: 1.5 }}>
                      Once you subscribe, your First Mover rate is locked for as long as you stay subscribed.
                    </div>

                    {/* Comparison table — full feature breakdown for eligible coaches */}
                    <div style={{ marginTop: '36px', paddingTop: '32px', borderTop: '1px solid rgba(192,132,252,0.18)' }}>
                      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 700, fontSize: '11px', letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FBBF24', marginBottom: '8px' }}>
                          Full Comparison
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '20px', color: '#fff', letterSpacing: '-0.01em' }}>
                          What's included in each plan
                        </div>
                      </div>
                      <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(192,132,252,0.18)', borderRadius: '12px', overflow: 'hidden', fontSize: '13px', color: '#E9D5FF' }}>
                          <thead>
                            <tr style={{ background: 'rgba(255,255,255,0.04)' }}>
                              <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#A78BFA' }}>Feature</th>
                              <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: 700, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#C084FC' }}>Network</th>
                              <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: 700, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#C084FC' }}>Verified</th>
                              <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: 700, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#FBBF24' }}>Lifetime</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[
                              ['Professional marketplace profile', true, true, true],
                              ['Resource library and community', true, true, true],
                              ['Scheduling and booking', true, true, true],
                              ['Accountability tracker', true, true, true],
                              ['Program management', true, true, true],
                              ['Marketplace Ads', true, true, true],
                              ['Active listings', '3', '10', '10'],
                              ['Monthly coaching industry insights', true, true, true],
                              ['Viveka Verification badge', false, true, true],
                              ['Priority search placement', false, true, true],
                              ['File uploads', false, true, true],
                              ['Reporting and analytics', false, true, true],
                              ['Enterprise client opportunities', false, true, true],
                              ['Viveka spotlight features', false, true, true],
                              ['Lifetime status (no renewals)', false, false, true],
                              ['Locked-in price (no future increases)', false, false, true],
                            ].map(function(row, i) {
                              var renderCell = function(v, isLifetimeCol) {
                                if (v === true) return <span style={{ color: isLifetimeCol ? '#FBBF24' : '#C084FC', fontWeight: 700 }}>{'\u2713'}</span>;
                                if (v === false) return <span style={{ color: 'rgba(255,255,255,0.25)' }}>{'\u2014'}</span>;
                                return <strong style={{ color: isLifetimeCol ? '#FBBF24' : '#C084FC' }}>{v}</strong>;
                              };
                              return (
                                <tr key={i} style={{ borderTop: '1px solid rgba(192,132,252,0.08)' }}>
                                  <td style={{ padding: '12px 16px', color: '#E9D5FF' }}>{row[0]}</td>
                                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>{renderCell(row[1], false)}</td>
                                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>{renderCell(row[2], false)}</td>
                                  <td style={{ padding: '12px 16px', textAlign: 'center' }}>{renderCell(row[3], true)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  /*
                    ── Standard pricing panel ──────────────────────
                    Coaches who signed up on or after May 1, 2026 see
                    the current ongoing pricing. Network $19/mo or
                    $197/year ($31 saved); Verified $49/mo or $497/year
                    ($91 saved). Lifetime is reserved for Viveka First
                    100 (eligible coaches only) and is not offered here.
                  */
                  <div style={{
                    marginTop: '8px',
                    padding: '36px 32px',
                    borderRadius: '20px',
                    background: '#fff',
                    border: '1px solid rgba(139,92,246,0.12)',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.04), 0 8px 24px rgba(88,28,135,0.04)',
                  }}>
                    {/* Header */}
                    <div style={{ textAlign: 'center', maxWidth: '560px', margin: '0 auto 24px' }}>
                      <h2 style={{
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                        fontWeight: 800,
                        fontSize: '24px',
                        color: '#1E1040',
                        margin: '0 0 10px',
                        letterSpacing: '-0.02em',
                      }}>
                        Choose your subscription
                      </h2>
                      <p style={{ fontSize: '14px', color: '#6B7280', lineHeight: 1.6, margin: 0 }}>
                        Subscribe monthly or save with annual. Cancel anytime during the trial.
                      </p>
                    </div>

                    {/* Monthly / Annual billing cycle toggle */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
                      <div
                        role="tablist"
                        aria-label="Billing cycle"
                        style={{
                          display: 'inline-flex',
                          background: '#F3E8FF',
                          border: '1px solid rgba(139,92,246,0.18)',
                          borderRadius: '999px',
                          padding: '4px',
                        }}
                      >
                        <button
                          type="button"
                          role="tab"
                          aria-selected={!isAnnual}
                          onClick={() => setIsAnnual(false)}
                          style={{
                            background: !isAnnual ? '#8B5CF6' : 'transparent',
                            color: !isAnnual ? '#fff' : '#581C87',
                            border: 'none',
                            padding: '8px 22px',
                            borderRadius: '999px',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.04em',
                            cursor: 'pointer',
                            transition: 'all .2s ease',
                          }}
                        >
                          Monthly
                        </button>
                        <button
                          type="button"
                          role="tab"
                          aria-selected={isAnnual}
                          onClick={() => setIsAnnual(true)}
                          style={{
                            background: isAnnual ? '#8B5CF6' : 'transparent',
                            color: isAnnual ? '#fff' : '#581C87',
                            border: 'none',
                            padding: '8px 22px',
                            borderRadius: '999px',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.04em',
                            cursor: 'pointer',
                            transition: 'all .2s ease',
                          }}
                        >
                          Annual
                        </button>
                      </div>
                    </div>

                    {/* Cards grid */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))',
                      gap: '16px',
                      alignItems: 'stretch',
                      maxWidth: '720px',
                      margin: '0 auto',
                    }}>
                      {/* Network Member */}
                      <div style={{
                        background: '#fff',
                        border: '1px solid rgba(139,92,246,0.18)',
                        borderRadius: '14px',
                        padding: '28px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                      }}>
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#8B5CF6', marginBottom: '12px' }}>
                          Network Member
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '34px', color: '#1E1040', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          {isAnnual ? '$197' : '$19'}<span style={{ fontSize: '14px', fontWeight: 500, color: '#6B7280' }}>{isAnnual ? '/year' : '/mo'}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#8B5CF6', marginTop: '6px', fontWeight: 500 }}>
                          {isAnnual ? 'Save $31/year vs monthly' : '7-day free trial'}
                        </div>
                        <ul style={{ margin: '20px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '13px', lineHeight: 1.6, color: '#374151' }}>
                          <li style={{ padding: '4px 0' }}>Professional coaching profile in the Viveka marketplace</li>
                          <li style={{ padding: '4px 0' }}>Visibility to individuals and organizations seeking coaching</li>
                          <li style={{ padding: '4px 0' }}>Invitations to Viveka hosted events and webinars</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => openChargebeePortal(activeStdNetworkPlanId)}
                          disabled={getSubscriptionType() === activeStdNetworkPlanId}
                          style={{
                            background: 'transparent',
                            color: '#581C87',
                            border: '1px solid rgba(139,92,246,0.4)',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '14px',
                            cursor: getSubscriptionType() === activeStdNetworkPlanId ? 'default' : 'pointer',
                            opacity: getSubscriptionType() === activeStdNetworkPlanId ? 0.5 : 1,
                          }}
                        >
                          {getSubscriptionType() === activeStdNetworkPlanId ? 'Current' : (isAnnual ? 'Subscribe Annually' : (subscription ? 'Switch to Network' : 'Start 7-Day Free Trial'))}
                        </button>
                      </div>

                      {/* Verified Coach (featured) */}
                      <div style={{
                        background: 'linear-gradient(180deg, #FAF5FF 0%, #fff 100%)',
                        border: '1px solid #8B5CF6',
                        borderRadius: '14px',
                        padding: '32px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        boxShadow: '0 8px 24px rgba(139,92,246,0.12)',
                      }}>
                        <div style={{
                          position: 'absolute',
                          top: '-12px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
                          color: '#fff',
                          fontFamily: "'Plus Jakarta Sans', sans-serif",
                          fontWeight: 700,
                          fontSize: '11px',
                          letterSpacing: '0.14em',
                          textTransform: 'uppercase',
                          padding: '5px 14px',
                          borderRadius: '999px',
                          whiteSpace: 'nowrap',
                        }}>
                          Most Active Coaches
                        </div>
                        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.10em', textTransform: 'uppercase', color: '#8B5CF6', marginBottom: '10px', marginTop: '8px' }}>
                          {isAnnual ? 'Verified Coach — Annual' : 'Verified Coach — Monthly'}
                        </div>
                        <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: '34px', color: '#1E1040', lineHeight: 1, letterSpacing: '-0.02em' }}>
                          {isAnnual ? '$497' : '$49'}<span style={{ fontSize: '14px', fontWeight: 500, color: '#6B7280' }}>{isAnnual ? '/year' : '/mo'}</span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#8B5CF6', marginTop: '6px', fontWeight: 500 }}>
                          {isAnnual ? 'Save $91/year vs monthly' : '7-day free trial'}
                        </div>
                        <ul style={{ margin: '20px 0', padding: 0, listStyle: 'none', flex: 1, fontSize: '13px', lineHeight: 1.6, color: '#374151' }}>
                          <li style={{ padding: '4px 0' }}>Viveka Verification badge with priority placement on Marketplace Ads</li>
                          <li style={{ padding: '4px 0' }}>Eligibility for enterprise coaching engagements</li>
                          <li style={{ padding: '4px 0' }}>Featured in Viveka spotlight opportunities</li>
                        </ul>
                        <button
                          type="button"
                          onClick={() => openChargebeePortal(activeStdVerifiedPlanId)}
                          disabled={getSubscriptionType() === activeStdVerifiedPlanId}
                          style={{
                            background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
                            color: '#fff',
                            border: 'none',
                            padding: '14px 24px',
                            borderRadius: '10px',
                            fontWeight: 700,
                            fontSize: '14px',
                            cursor: getSubscriptionType() === activeStdVerifiedPlanId ? 'default' : 'pointer',
                            opacity: getSubscriptionType() === activeStdVerifiedPlanId ? 0.5 : 1,
                            boxShadow: '0 4px 12px rgba(139,92,246,0.3)',
                          }}
                        >
                          {getSubscriptionType() === activeStdVerifiedPlanId ? 'Current' : (isAnnual ? 'Subscribe Annually' : (subscription ? 'Switch to Verified' : 'Apply for Verification'))}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {subscriptionDetails && subscriptionDetails.subscription === 2 && (
                  <div className={css.subscriptionDetails}>
                    <div className={css.subscriptionName}>
                      <div className={css.subscriptionTitle}>Current Subscription</div>
                      <div>{getSubscriptionName(getSubscriptionType())}</div>
                    </div>

                    {!subscriptionCancellation ? (
                      <div className={css.subscriptionAction}>
                        <ReactTooltip
                          className={css.tooltip}
                          place={'right'}
                          effect={'solid'}
                          delayHide={10}
                        />
                        <FontAwesomeIcon
                          data-tip="This will schedule a cancellation of the subscription to trigger on the term end and your coupon will be removed as well"
                          className={css.hintIcon}
                          icon={faQuestionCircle}
                        />
                        <div
                          onClick={() => onRemoveButtonClick()}
                          className={css.subscriptionRemoveButton}
                        >
                          Cancel
                        </div>
                      </div>
                    ) : (
                      <p>Subscription will be cancelled on the term end</p>
                    )}
                  </div>
                )}

                <PaymentTable1 />
                <PaymentTable2 style={{ marginTop: '50px' }} />
              </div>
            </SettingsLayoutWrapper>
          ) : (
            <SettingsLayoutWrapper page="withdrawal">
              <div className={css.outerbase}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div className={css.leftDivDes}>
                    <p>Payout</p>
                    <p>References</p>
                  </div>
                  <div className={css.rightDivDes}></div>
                </div>

                <div className={css.base}>
                  <div className={classnames(css.leftDiv, css.stripeConfig)}>
                    <p>Bank account</p>
                    <p>
                      To receive money to your bank account, you need to provide your bank details.
                      Your customers will be able to pay with their credit card.
                    </p>
                    <div></div>
                    <div className={css.content}>
                      {!currentUserLoaded ? (
                        <FormattedMessage id="StripePayoutPage.loadingData" />
                      ) : (
                        <StripeConnectAccountForm
                          disabled={formDisabled}
                          inProgress={payoutDetailsSaveInProgress}
                          ready={payoutDetailsSaved}
                          stripeBankAccountLastDigits={getBankAccountLast4Digits(stripeAccountData)}
                          savedCountry={savedCountry}
                          submitButtonText={intl.formatMessage({
                            id: 'StripePayoutPage.submitButtonText',
                          })}
                          stripeAccountError={
                            createStripeAccountError ||
                            updateStripeAccountError ||
                            fetchStripeAccountError
                          }
                          stripeAccountFetched={stripeAccountFetched}
                          onChange={onPayoutDetailsFormChange}
                          onSubmit={onPayoutDetailsFormSubmit}
                          onGetStripeConnectAccountLink={handleGetStripeConnectAccountLink}
                          stripeConnected={stripeConnected}
                        >
                          {stripeConnected && (showVerificationError || showVerificationNeeded) ? (
                            <StripeConnectAccountStatusBox
                              type={
                                showVerificationError ? 'verificationError' : 'verificationNeeded'
                              }
                              inProgress={getAccountLinkInProgress}
                              onGetStripeConnectAccountLink={handleGetStripeConnectAccountLink(
                                'custom_account_verification'
                              )}
                            />
                          ) : stripeConnected && savedCountry ? (
                            <StripeConnectAccountStatusBox
                              type="verificationSuccess"
                              inProgress={getAccountLinkInProgress}
                              disabled={payoutDetailsSaveInProgress}
                              onGetStripeConnectAccountLink={handleGetStripeConnectAccountLink(
                                'custom_account_update'
                              )}
                            />
                          ) : null}
                        </StripeConnectAccountForm>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </SettingsLayoutWrapper>
          )}
        </div>
      </MainDashboardWrapper>
    </PageWrapper>
  );
};

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

StripePayoutPageComponent.defaultProps = {
  currentUser: null,
  createStripeAccountError: null,
  updateStripeAccountError: null,
  fetchStripeAccountError: null,
  stripeAccount: null,
  params: {
    returnURLType: null,
    tab: 'pricing',
  },
};

StripePayoutPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,
  getAccountLinkInProgress: bool.isRequired,
  payoutDetailsSaveInProgress: bool.isRequired,
  createStripeAccountError: propTypes.error,
  updateStripeAccountError: propTypes.error,
  fetchStripeAccountError: propTypes.error,
  stripeAccount: propTypes.stripeAccount,
  payoutDetailsSaved: bool.isRequired,
  onPayoutDetailsFormChange: func.isRequired,
  onPayoutDetailsFormSubmit: func.isRequired,
  onGetStripeConnectAccountLink: func.isRequired,
  params: shape({
    returnURLType: oneOf(STRIPE_ONBOARDING_RETURN_URL_TYPES),
    tab: string.isRequired,
  }),
  callSetInitialValues: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const {
    getAccountLinkInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
  } = state.stripeConnectAccount;
  const { currentUser } = state.user;
  const { payoutDetailsSaveInProgress, payoutDetailsSaved } = state.StripePayoutPage;
  return {
    currentUser,
    getAccountLinkInProgress,
    createStripeAccountError,
    updateStripeAccountError,
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
    payoutDetailsSaveInProgress,
    payoutDetailsSaved,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onPayoutDetailsFormChange: () => dispatch(stripeAccountClearError()),
  onPayoutDetailsFormSubmit: (values, isUpdateCall) =>
    dispatch(savePayoutDetails(values, isUpdateCall)),
  onGetStripeConnectAccountLink: params => dispatch(getStripeConnectAccountLink(params)),
  callSetInitialValues: (setInitialValues, values) => dispatch(setInitialValues(values)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchCurrentUser: () => dispatch(fetchCurrentUser()),
  onRemoveSubscription: () => dispatch(removeSubscription()),
  onReactivateSubscription: () => dispatch(reactivateSubscription()),
  onCheckProfileCompleted: () => dispatch(checkProfileCompleted()),
  onFetchPortalSession: () => dispatch(fetchPortalSession()),
});

const StripePayoutPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(StripePayoutPageComponent);

StripePayoutPage.loadData = loadData;

export default withRouter(StripePayoutPage);
